export function isCategoryProduct(item) {
  return Boolean('price' in item && item.price && item.currency);
}
